import http from '~/utils/http'

/** 结算时证据不足以定案的课：师生有一段在线时间无法确认，补上与不补会得出不同结论 */
export interface AttendanceReviewEvidence {
  teacherSeconds: number
  studentSeconds: number
  overlapSeconds: number | null
  teacherUnverifiedSeconds: number
  studentUnverifiedSeconds: number
  teacherLateSeconds: number
  started: boolean
  studentMissed: boolean
  studentEntered: boolean
  endedByTeacher: boolean
  maxAttendanceSeconds: number
  maxOverlapSeconds: number
}

/** RECORDED：按已确认时长结算；VERIFIED：管理员核实后填入的时长 */
export interface AttendanceReviewResolution {
  decision: 'RECORDED' | 'VERIFIED'
  note: string
  teacherSeconds?: number | null
  studentSeconds?: number | null
  overlapSeconds?: number | null
}

export interface AttendanceReview {
  appointmentId: string
  status: 'PENDING' | 'RESOLVED'
  candidateReason: string
  evidence: AttendanceReviewEvidence
  createdAt: number
  resolvedAt: number | null
  resolvedBy: string | null
  resolution: AttendanceReviewResolution | null
  studentId: string | null
  studentName: string | null
  teacherId: string | null
  teacherName: string | null
  classStartTime: number | null
}

export async function listAttendanceReviews(status: 'PENDING' | 'RESOLVED', page: number, size: number) {
  const response = await http.get<{ content: AttendanceReview[]; total: number }>('/admin/classroom-attendance-reviews', {
    params: { status, page, size },
  })
  return response.data
}

export async function resolveAttendanceReview(appointmentId: string, resolution: AttendanceReviewResolution) {
  const response = await http.post<AttendanceReview>(
    `/admin/classroom-attendance-reviews/${encodeURIComponent(appointmentId)}/resolve`,
    resolution,
  )
  return response.data
}
